import { ApplicationForm } from './ApplicationForm'
import { BasicInformation } from './BasicInformation'
import { Description } from './Description'
import { EvaluationForms } from './EvaluationForms'
import { HiringPipeline } from './HiringPipeline'
import { HiringTeam } from './HiringTeam'
import { SmartActions } from './SmartActions'

interface Props {
  selected: string
  jobId: number
  companyId: number
}

export const SectionComponent = ({ selected, jobId, companyId }: Props) => {
  switch (selected) {
    case 'basic-info':
      return <BasicInformation jobId={jobId} />
    case 'description':
      return <Description jobId={jobId} />
    case 'application-form':
      return <ApplicationForm jobId={jobId} />
    case 'hiring-pipeline':
      return <HiringPipeline jobId={jobId} />
    case 'hiring-team':
      return <HiringTeam jobId={jobId} companyId={companyId} />
    case 'internal-evaluation-forms':
      return <EvaluationForms jobId={jobId} />
    case 'smart-actions':
      return <SmartActions jobId={jobId} />
    default:
      return <div>default - {jobId}</div>
  }
}
